// const serverUrl = 'http://localhost:8080';
const serverUrl = 'https://svtepra.butonkab.go.id/';
// const serverUrl = 'https://e-monev.datasatu-ind.com/';

export { serverUrl }